import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/lp-logo-white.svg'


const _hoisted_1 = { class: "ly-col ly-center-center reset-password-container" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "ly-row mt-2" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "" }

import { ref, computed, inject, Ref } from 'vue'
import PasswordPoliciesList from '@/views/Common/components/PasswordPoliciesList.vue'
import { useConfigSync } from '@/config/useConfig'


export default /*@__PURE__*/_defineComponent({
  __name: 'ResetHashPasswordView',
  setup(__props) {


const newPassword: Ref<string> = ref('')
const repeatPassword: Ref<string> = ref('')
const config = useConfigSync()
const resetPasswordHashFlow = inject('resetPasswordHashFlow') as (newPassword: string, hashedPassword: string) => Promise<void>
const getQueryParameter = inject('getQueryParameter') as (paramName: string) => string
const submitting: Ref<boolean> = ref(false)
const errorMessage: Ref<string> = ref('')

const formSubmitted = async () => {
  if (submitting.value || !isNewPasswordValid()) return

  submitting.value = true
  try {
    await resetPasswordHashFlow(newPassword.value, getQueryParameter('key'))
  } catch (error: any) {
    errorMessage.value = error.message
  }
  submitting.value = false
}

const isNewPasswordValid = () => {
  if (newPassword.value && repeatPassword.value && newPassword.value === repeatPassword.value) {
    return true
  } else {
    return false
  }
}

const disableSubmitButton = computed(() => !isNewPasswordValid() || submitting.value)

const isSymbolsPolicyMeet = computed((): boolean => {
  if (!config.password_policy.require_symbols) return true
  return (/[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+-]/.test(newPassword.value))
})

const isLengthPolicyMeet = computed((): boolean => {
  return newPassword.value.length >= config?.password_policy.minimum_length
})

const isLowercasePolicyMeet = computed((): boolean => {
  if (!config.password_policy.require_lowercase) return true
  return (/[a-z]/.test(newPassword.value))
})

const isRequireNumberPolicyMeet = computed((): boolean => {
  if (!config.password_policy.require_numbers) return true
  return /\d/.test(newPassword.value)
})

const isUppercasePolicyMeet = computed((): boolean => {
  if (!config.password_policy.require_uppercase) return true
  return (/[A-Z]/.test(newPassword.value))
})


return (_ctx: any,_cache: any) => {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_lp_button = _resolveComponent("lp-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("img", {
      src: _imports_0,
      class: "mb-3"
    }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h3", null, "Set New Password", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "msg" }, "Now that you've confirmed your email, please enter a new password twice below.", -1)),
      _createElementVNode("form", {
        onSubmit: _withModifiers(formSubmitted, ["prevent"]),
        class: "form-reset-password"
      }, [
        _createVNode(_component_lp_input, {
          modelValue: newPassword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newPassword).value = $event)),
          type: "password",
          "label-top": "New password"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_lp_input, {
          modelValue: repeatPassword.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((repeatPassword).value = $event)),
          type: "password",
          "label-top": "Confirm password",
          compact: ""
        }, null, 8, ["modelValue"]),
        _createVNode(PasswordPoliciesList, {
          isSymbolsPolicyMeet: isSymbolsPolicyMeet.value,
          isLengthPolicyMeet: isLengthPolicyMeet.value,
          isLowercasePolicyMeet: isLowercasePolicyMeet.value,
          isRequireNumberPolicyMeet: isRequireNumberPolicyMeet.value,
          isUppercasePolicyMeet: isUppercasePolicyMeet.value
        }, null, 8, ["isSymbolsPolicyMeet", "isLengthPolicyMeet", "isLowercasePolicyMeet", "isRequireNumberPolicyMeet", "isUppercasePolicyMeet"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_lp_button, {
            disabled: disableSubmitButton.value,
            loading: submitting.value,
            type: "primary",
            class: "btn-loading-active"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("Submit", -1)
            ]))]),
            _: 1
          }, 8, ["disabled", "loading"])
        ])
      ], 32),
      (errorMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(errorMessage.value), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})